module.exports = __webpack_public_path__ + "static/media/ordfortåelsepreview.f5bc12ec.mp4";